// extracted by mini-css-extract-plugin
export default {"wrapper":"FLFhQ","variantsWrapper":"Ld_jc","variant":"B6TM_","textWrapper":"f9tju","text":"_ZLBH","select":"fBJlm"};